import httpClient from '../utils/axios'
import {
  handleServiceResponse,
  handleServiceError,
} from '../utils/serviceResponseHelper'

const getEditableRegionInputTypeDescription = inputTypeId => {
  switch (inputTypeId) {
    case 1:
      return 'Free Text'
    case 2:
      return 'Date Picker'
    case 3:
      return 'Time Picker'
    case 4:
      return 'Drop Down'
    case 5:
      return 'Html Editor'
    case 6:
      return 'Carousel'
    default:
      return 'N/A'
  }
}

const minEditableNameLength = 3
const maxEditableNameLength = 100

const checkNameIsValid = (name, currentEditables) => {
  if (name.length < minEditableNameLength)
    return {
      isValid: false,
      message: `Name must be at least ${minEditableNameLength} characters`,
    }
  if (name.length > maxEditableNameLength)
    return {
      isValid: false,
      message: `Name must be a maximum of ${maxEditableNameLength} characters or fewer`,
    }
  if (currentEditables.find(x => x.name.toLowerCase() === name.toLowerCase()))
    return { isValid: false, message: 'Name already exists' }
  return { isValid: true, message: 'Valid Input' }
}

const checkInputTypeIdIsValid = inputTypeId => {
  if (inputTypeId === 0) return false
  return true
}

const checkMinLengthIsValid = (inputTypeId, minLength, maxLength) => {
  if (inputTypeId !== 1) return true
  if (minLength < 1) return false
  if (minLength > maxLength) return false
  return true
}

const checkMaxLengthIsValid = (inputTypeId, minLength, maxLength) => {
  if (inputTypeId !== 1) return true
  if (maxLength > 100) return false
  if (maxLength < minLength) return false
  return true
}

const checkOptionsAreValid = (inputTypeId, options) => {
  if (inputTypeId === 4 || inputTypeId === 6) {
    if (options.filter(x => !x.isArchived).length < 2) return false
  }
  return true
}

const checkEditableIsValid = (editable, currentEditables) => {
  return (
    checkNameIsValid(editable.name, currentEditables) &&
    checkInputTypeIdIsValid(editable.inputTypeId) &&
    checkMinLengthIsValid(
      editable.inputTypeId,
      editable.minLength,
      editable.maxLength
    ) &&
    checkMaxLengthIsValid(
      editable.inputTypeId,
      editable.minLength,
      editable.maxLength
    ) &&
    checkOptionsAreValid(editable.inputTypeId, editable.editableRegionOptions)
  )
}

const getEditableRegions = async () => {
  return httpClient
    .get(`${window.config.DOCUMENT_API_URL}/v1/editableregion/getall`)
    .then(
      response => handleServiceResponse(response),
      error => handleServiceError(error)
    )
}

const getEditableRegion = async id => {
  return httpClient
    .get(
      `${window.config.DOCUMENT_API_URL}/v1/editableregion/get?regionId=${id}`
    )
    .then(
      response => handleServiceResponse(response),
      error => handleServiceError(error)
    )
}

const addEditableRegion = async newRegion => {
  return httpClient
    .post(
      `${window.config.DOCUMENT_API_URL}/v1/editableregion/create`,
      newRegion
    )
    .then(
      response => handleServiceResponse(response),
      error => handleServiceError(error)
    )
}

const updateEditableRegion = async updatedRegion => {
  return httpClient
    .put(
      `${window.config.DOCUMENT_API_URL}/v1/editableregion/update`,
      updatedRegion
    )
    .then(
      response => handleServiceResponse(response),
      error => handleServiceError(error)
    )
}

const getMergeFields = async () => {
  return httpClient
    .get(
      `${window.config.DOCUMENT_API_URL}/v1/editableregion/GetAllMergeFields`
    )
    .then(
      response => handleServiceResponse(response),
      error => handleServiceError(error)
    )
}

export {
  getEditableRegionInputTypeDescription,
  checkNameIsValid,
  checkInputTypeIdIsValid,
  checkMaxLengthIsValid,
  checkMinLengthIsValid,
  checkOptionsAreValid,
  checkEditableIsValid,
  getEditableRegions,
  getEditableRegion,
  addEditableRegion,
  updateEditableRegion,
  getMergeFields,
}
